import { Component }                 from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';
import { SignInViewModel }           from './xv-sign-in';
import { SelectLangViewModel }       from './xv-select-lang-popover';

@Component({
     selector:    'page-select-lang-popover'
    ,templateUrl: 'select-lang-popover.html'
})
export class SelectLangPopoverPage {
    SelectLang: SelectLangViewModel;
    Dismiss:    (pAction: () => void) => void;

    constructor(
         public viewCtrl:  ViewController
        ,public navParams: NavParams
    ) {
        this.Dismiss    = (pAction: () => void) => {
            this.viewCtrl.dismiss(pAction);
        };

        this.SelectLang = new SelectLangViewModel(
            this.Dismiss
        );

        this.SelectLang.Initialise(
            this.navParams.data.signIn as SignInViewModel
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/sign-in/select-lang-popover.ts